import * as types from './mutation-types'


export default {
}
